export const SAVE_SHIPPING_ADDRESS = 'SAVE_SHIPPING_ADDRESS'
export const RESET_SHIPPING_ADDRESS = 'REST_SHIPPING_ADDRESS'
export const SAVE_TOTAL_PRICE = 'SAVE_TOTAL_PRICE'
export const RESET_TOTAL_PRICE = 'RESET_TOTAL_PRICE'

export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST'
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCCESS'
export const ORDER_CREATE_FAIL = 'ORDER_CREATE_FAIL'
export const  ORDER_CREATE_RESET ='ORDER_CREATE_RESET'